import { smtpSystemConfigurationsApi } from '../api/smtpSystemConfigurations.api';
import { useDataTable } from '../../../hooks/useDataTable';
export const useSmtpSystemConfigurations = (searchData = []) => {
  const table = useDataTable(smtpSystemConfigurationsApi);
  return {
    ...table,
  };
};
